/**
 * Mirrors apps/api/src/modules/feedback/feedback.constants.ts. The web bundler cannot
 * import API source, so the values are repeated here and `__parity__/feedback.parity.test.ts`
 * fails the build if they drift.
 */

export const FEEDBACK_TAGS = [
  'questions_hard',
  'questions_easy',
  'question_error',
  'similar_to_real',
  'not_similar_to_real',
  'explanations_helpful',
  'explanations_unclear',
  'topics_match_exam',
] as const;

export type FeedbackTag = (typeof FEEDBACK_TAGS)[number];

export const FEEDBACK_RATING_MIN = 1;
export const FEEDBACK_RATING_MAX = 5;
export const FEEDBACK_COMMENT_MAX_LENGTH = 1000;

export const FEEDBACK_RATINGS = [1, 2, 3, 4, 5] as const;
